const StrikethroughText = () => (
  <>
    <path
      fill="currentColor"
      d="M15.929 7.243c-1.675-2.792-4.669-2.68-6.256-1.309-.8.691-1.276 1.734-.986 2.884.191.758.701 1.501 1.566 2.182H5.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-6.38c-1.61-.827-2.283-1.712-2.463-2.427-.18-.71.095-1.386.67-1.882 1.163-1.005 3.42-1.142 4.744 1.066a.5.5 0 1 0 .858-.514M16.302 14.319a.5.5 0 1 0-.931.362c.248.64.132 1.252-.236 1.783-.377.544-1.02.998-1.787 1.24-1.516.478-3.39.095-4.4-1.928a.5.5 0 1 0-.895.447c1.269 2.538 3.697 3.033 5.596 2.435.941-.297 1.784-.87 2.308-1.624.531-.768.73-1.727.345-2.715"
    />
  </>
)
export default StrikethroughText
